import React, { useContext, useRef, useState, useMemo, useEffect, useCallback } from 'react';
import { MainContext } from 'context/mainContext';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { IconPDF } from 'eva-component/ui/icon';
import { Button } from 'reactstrap';
import CustomSpinner from 'components/Misc/CustomSpinner';
import { ClipLoader } from 'react-spinners';
import { generateUUID } from 'services/EVAResponseService';
import EVAAnswer from 'eva-component/response/EVAAnswer';
import DashboardVisual from './DashboardVisual';
import moment from "moment";
import DataAnalyzerComponentItem from './DataAnalyzerComponentItem';
var momentTZ = require("moment-timezone");

const DataAnalyzerComponent = ({ handleToggleAnalyzerModal, item, selectedDashboardTemplate, isEVAAnalyseDashboard, handleToggleDashboardModal, selectedTemplate }) => {
    const { bgColor, userDetails, selectedClientID, firmDetails } = useContext(MainContext);
    const reportRef = useRef(null);
    const [isExporting, setIsExporting] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [evaAnswer, setEVAAnswer] = useState(null)
    const [query, setQuery] = useState(null)
    const [selectedItem, setSelectedItem] = useState(item)
    const [dashboardItems, setDashboardItems] = useState([])
    const [dashboardLastRefresh, setDashboardLastRefresh] = useState(null)
    const dashboardRefs = useRef([]);
    useEffect(() => {
        const processData = async () => {
            if(!isEVAAnalyseDashboard)
            {
                if(item.visual_type === "Card") {

                    if(selectedTemplate) {
                        const selectedDashboardItem = selectedDashboardTemplate.dashboardTemplate.find(i => i.my_row_id === selectedItem.my_row_id);

                        if (selectedDashboardItem) {
                            selectedDashboardItem.visualData = item.visualData || {};
                            selectedDashboardItem.visualData.templateItemVisual = selectedDashboardItem.visual;
                            selectedDashboardItem.integrationImage = item.integrationImage;
                            selectedDashboardItem.lastRefreshData = item.lastRefreshData;
                            setSelectedItem(selectedDashboardItem)
                        } else {
                            console.warn("selectedDashboardItem not found for row_id:", selectedItem.my_row_id);
                        }
                    }
                }
            } else {
           
                const dashboard = selectedDashboardTemplate
                if(dashboard && dashboard?.dashboardTemplate && dashboard?.dashboardTemplate.length > 0) {
                    setDashboardItems(dashboard.dashboardTemplate)
                    setDashboardLastRefresh(dashboard?.dashboardTemplate[0].lastRefreshData?.lastRefresh)
                    const combinedData = []
                    dashboard?.dashboardTemplate.map(item => {
                        combinedData.push({ header: item.visual_type === "Card" ? item.cleanedHeader : item.header, body: item.sqlresult})
                    })
                    processEVAIntro(userDetails.User, selectedClientID, firmDetails.AccountingFirmID, combinedData)
                }
            }
        }
        processData()
    }, [selectedItem])
    
    const processEVAIntro = useCallback(async (user, ClientId, businessId, combinedData) => {
        const query = `analyser, query: '', data: ${JSON.stringify(combinedData)}`;

        const uuid = await generateUUID()
        const raw = {
            "chatId": uuid,
            "query": query,
            "UserInfo": {
                "chatId": uuid,
                "UserId": user.UserID,
                "Name": `${user.FirstName} ${user.LastName}`,
                "ClientId": ClientId,
                "BusinessId": businessId
            }
        };
        try {
            const response = await fetch('https://evabetaprod.azurewebsites.net/eva_stream', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify(raw)
            });
            
            const reader = response.body.getReader();
            let chunks = '';
            const streamMessageArray = []
        
            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                chunks += new TextDecoder().decode(value);
                const messagesArray = chunks.split('\n');
                streamMessageArray.push(chunks)
                // setStreamMessage([...streamMessageArray])
            }
        
            const msg = streamMessageArray[streamMessageArray.length - 1]
        
            const EVAResponse = {
                "user": {
                    "_id": "1",
                    "sender": "1",
                    "name": "EVA"
                },
                "_id": "",
                "uuid": "",
                "clientid": "6780e66b-26c5-4a2f-b622-a7ab85de0eb1",
                "userid": "85cf8335-36e3-48d8-bd00-e5cbd4e6c266",
                "query": "",
                "text": get_answer(msg),
                "sender": "1",
                "__v": 0,
                formatedResponse: {
                "answer": get_answer(msg),
                "observation": "",
                "parsedData": [],
                "integration": "",
                "headers": [],
                "treeViewData": [],
                "isWithChild": false,
                "version": "1.1.2411.07064",
                "stext": "",
                "groupLevel": 1,
                "newTreeData": [],
                "newTreeDataWithGrandTotal": []
                }
            }

            setEVAAnswer(EVAResponse.formatedResponse.answer)
            setQuery(EVAResponse.query)

            function get_answer(validJsonString) {
                try {
                    const updatedString = validJsonString.replace(/\\n/g, "`nl` ")
                    const res = JSON.parse(updatedString)
                    return res.answer
                } catch {
                    let startIdx = validJsonString.indexOf('"answer":');
                    if(startIdx < 0) startIdx = validJsonString.indexOf(`"answer":`); 
        
                    let endIdx = validJsonString.indexOf('"observation":');
                    let answer = validJsonString.substring(startIdx + ( validJsonString.indexOf(`"answer":`) !== -1 ? 11 : 14), endIdx - 11)
        
                    answer = textParcer(answer)
                    return answer.replace(/\\",/g, '.').replace(/\."/g, '.').replace(/\"/g, "'").replace(/',/g, "").replace("u2019","'");
                }
            }
            function textParcer(item) {
                return item
                .replace(/\\",/g, '')
                .replace(/\\t/g, "")
                .replace('"\n', "\n")
                .replace(/\\n/g, "`nl` ")
                // .replace(/\(/g, '[')
                // .replace(/\)/g, ']')
                .replace("   ", "")
                .replace(/\\'/g, '"')
                .replace(/\\"/g, '')
                .replace(/'/g, '"')
                .replace(/\\/g, '')
                .replace(/\\/g, '')
                .replace(/\: None/g, ': "None"')
                .replace(/\: Null/g, ': "None"')
                // .replace(/Decimal\(/g, '')
                .replace(/\),/g, ',')
                .replace(/\)}/g, '}');
            }
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }

    }, [])

    const FormattedAnswer = ({answer}) => {
        if (typeof answer !== 'string') {
            console.warn('FormattedAnswer expected a string but received:', answer);
            return '';
        }
    
        const htmlString = answer
            // .replace(/`nl`/g, '\n')
            .replace(/^# (.*?)`nl` `nl`/g, '<h1>$1</h1>')
            .replace(/### (.*?)(`nl`|\n|:)/g, '<div class="noteHeader">📈 $1</div>')
            .replace(/## (.*?)(`nl`|\n|:)/g, '<div class="noteHeader">📈 $1</div>')
            // .replace(/## (.*?):/g, '<div class="noteHeader">📈 $1</div>')
            .replace(/`nl`/g, '<div></div>')
            .replace(/## Key Insights:/g, '<div class="noteHeader">💡 Key Insights</div>')
            .replace(/ ## Recommendation:/g, '<div class="noteHeader">📌 Recommendations</div>')
            .replace(/^### (.*)$/gm, '<h3>$1</h3>')
            .replace(/^## (.*)$/gm, '<h2>$1</h2>')
            .replace(/^# (.*)$/g, '<h1>$1</h1>')
            // .replace(/^- (.*)$/gm, '<li>$1</li>')
            .replace(/(<li>.*?<\/li>)/gms, '<ul>$1</ul>')
            .replace(/- \*\*(.*?)\*\*/g, '<strong>$1</strong>')
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

        return (
            <div dangerouslySetInnerHTML={{ __html: htmlString }} />
        );
    };

    useEffect(() => {
        dashboardRefs.current = dashboardItems.map((_, i) => dashboardRefs.current[i] || React.createRef());
    }, [dashboardItems]);

    const handleExportToPDF = async () => {
        setIsExporting(true);
        
        try {
            const element = reportRef.current;
            if (!element) {
                console.error('Report element not found');
                return;
            }

            console.log('Element found:', element);
            console.log('Element dimensions:', {
                offsetWidth: element.offsetWidth,
                offsetHeight: element.offsetHeight,
                scrollWidth: element.scrollWidth,
                scrollHeight: element.scrollHeight
            });
    
            // Force explicit styling to ensure visibility
            const originalStyle = element.style.cssText;
            element.style.position = 'relative';
            element.style.display = 'block';
            element.style.visibility = 'visible';
            element.style.opacity = '1';
            element.style.backgroundColor = 'white';
            element.style.color = 'black';
            element.style.fontFamily = 'Arial, sans-serif';
            element.style.fontSize = '14px';
            element.style.zIndex = '9999';
    
            // Wait for styles to apply
            await new Promise(resolve => setTimeout(resolve, 100));
    
            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                logging: false,
                backgroundColor: '#ffffff',
                width: element.scrollWidth,
                height: element.scrollHeight,
                x: 0,
                y: 0,
                scrollX: 0,
                scrollY: 0,
                foreignObjectRendering: true,
                removeContainer: true,
                ignoreElements: (element) => {
                    // Skip any problematic elements
                    return element.tagName === 'IFRAME' || 
                        element.tagName === 'OBJECT' || 
                        element.tagName === 'EMBED';
                }
            });
    
            // Restore original styles
            element.style.cssText = originalStyle;
    
            console.log('Canvas created:', {
                width: canvas.width,
                height: canvas.height
            });
    
            const imgData = canvas.toDataURL('image/png', 1.0);
            
            if (!imgData || imgData === 'data:,' || imgData === 'data:image/png;base64,') {
                throw new Error('Canvas produced no image data');
            }
    
            console.log('Image data generated successfully');
    
            // Create PDF with better settings
            const pdf = new jsPDF('p', 'mm', 'a4');
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const margin = 15; // Slightly larger margin
            
            const imgWidth = pageWidth - 2 * margin;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            const pageContentHeight = pageHeight - 2 * margin;
    
            console.log('PDF dimensions:', {
                pageWidth,
                pageHeight,
                imgWidth,
                imgHeight,
                pageContentHeight
            });
    
            // Add a title page first
            // pdf.setFontSize(20);
            // pdf.text(`${item.name} Report`, margin, margin + 10);
            // pdf.setFontSize(12);
            
            for (let i = 0; i < dashboardItems.length; i++) {
                const visual = dashboardRefs.current[i]?.current;
            }
    
            // If content fits on remaining space of first page
            const remainingFirstPageHeight = pageContentHeight - 30; // Account for title
            if (imgHeight <= remainingFirstPageHeight) {
                pdf.addImage(imgData, 'PNG', margin, margin, imgWidth, imgHeight);
            } else {
                // Add content starting on second page
           
                
                if (imgHeight <= pageContentHeight) {
                    // Fits on one page
                    pdf.addImage(imgData, 'PNG', margin, margin, imgWidth, imgHeight);
                } else {
                    // Multi-page content
                    let yPosition = 0;
                    let pageNumber = 0;
    
                    while (yPosition < imgHeight) {
                        if (pageNumber > 0) {
                            pdf.addPage();
                        }
    
                        const remainingHeight = imgHeight - yPosition;
                        const heightForThisPage = Math.min(remainingHeight, pageContentHeight);
                        
                        // Create cropped canvas
                        const cropCanvas = document.createElement('canvas');
                        const cropCtx = cropCanvas.getContext('2d');
                        
                        const sourceY = (yPosition / imgHeight) * canvas.height;
                        const sourceHeight = (heightForThisPage / imgHeight) * canvas.height;
                        
                        cropCanvas.width = canvas.width;
                        cropCanvas.height = sourceHeight;
                        
                        // Fill with white background first
                        cropCtx.fillStyle = 'white';
                        cropCtx.fillRect(0, 0, cropCanvas.width, cropCanvas.height);
                        
                        cropCtx.drawImage(
                            canvas,
                            0, sourceY, canvas.width, sourceHeight,
                            0, 0, canvas.width, sourceHeight
                        );
    
                        const croppedImgData = cropCanvas.toDataURL('image/png', 1.0);
                        pdf.addImage(croppedImgData, 'PNG', margin, margin, imgWidth, heightForThisPage);
    
                        yPosition += pageContentHeight;
                        pageNumber++;
    
                        console.log(`Added page ${pageNumber + 1}, yPosition: ${yPosition}`);
                    }
                }
            }

            // pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, margin, margin + 20);
            pdf.save(`${isEVAAnalyseDashboard ? selectedDashboardTemplate.name.replace(/\s+/g, '_') : item.name.replace(/\s+/g, '_')}_Report.pdf`);
            console.log('PDF saved successfully');
        } catch (error) {
            console.error('Export to PDF failed:', error);
            alert(`PDF export failed: ${error.message}`);
        } finally {
            setIsExporting(false);
        }
    };

    const handleCloseAnalyseModal = () => {
        handleToggleAnalyzerModal(null)
        handleToggleDashboardModal(false)
    }
    return (
        <div className="data-analyzer-component-container">
            <div className="data-analyzer-component">
                <div className="data-analyzer-component-header">
                    {/* <h2>{item?.name} Analysis</h2> */}
                    <div className="data-analyzer-component-header-buttons">
                        <div className="export-to-pdf-button" onClick={handleExportToPDF} style={isExporting ? { padding: '8px' } : {}}>
                            {isExporting ? 
                            <>
                                <ClipLoader
                                    style={{ padding: '10px' }}
                                    color={"#fff"}
                                    size={25}
                                    margin={10}
                                />
                                Exporting...
                            </>
                            :
                            <>
                                <IconPDF stroke="#fff"/>
                                Export To PDF
                            </>}
                        </div>
                        <Button onClick={() => handleCloseAnalyseModal()} color={'danger'} type="button" size='sm'>
                            Exit
                        </Button>
                    </div>
                </div>

                <div 
                    style={{ 
                        display: 'block',
                        backgroundColor: '#ffffff',
                        color: '#000000',
                        fontFamily: 'Arial, sans-serif',
                        fontSize: '14px',
                        lineHeight: '1.4',
                        padding: '20px',
                        margin: '0',
                        position: 'relative',
                        width: '100%',
                        minHeight: '500px',
                        position: 'absolute',
                        top: 0,
                        background: 'none'
                    }} 
                    ref={reportRef}
                >
                    {isEVAAnalyseDashboard ? 
                    <>
                        <div className='EVAanalysisContainer' style={{ marginBottom: 20 }} key={0}>
                            <div className='EVAanalysisHeader'>
                                {/* <img src={selectedDashboardTemplate.integrationImage} alt="Integration Logo" />  */}
                                <div className='EVAAnalysisIntegration'>
                                    <span className='reportHeader'>    
                                        {selectedDashboardTemplate.name} Report
                                    </span>
                                    <span>
                                        {`Generated on: ${new Date().toLocaleDateString()}`}
                                    </span>
                                </div>
                            </div>
                            {isLoading ? 
                                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                                    <CustomSpinner /> 
                                </div>
                            :
                            <>
                                {evaAnswer &&
                                    <>
                                        <div className='EVAAnalyserResponseContainer'>
                                            <FormattedAnswer
                                                answer={evaAnswer} 
                                            />
                                        </div>
                                    </>   
                                }
                            </>}
                        </div>
                        {!isLoading &&
                        <>
                        <div className='flex' style={{ gap: 10, flexDirection: 'row', display: 'flex'}}>
                            <div style={{ width : 'calc(50% - 10px)', gap: 10, flexDirection: 'column', display: 'flex'}}>
                            {dashboardItems && dashboardItems.length > 0 && dashboardItems.map((item, index) => (
                                (item.visual_type !== "Grid" || (item.visual_type === "Grid" && item.visualData.gridHeader.length < 5)) && (
                                    index % 2 === 0 && (
                                        <>
                                            <DataAnalyzerComponentItem 
                                                item={item}
                                                index={index}
                                                selectedDashboardTemplate={selectedDashboardTemplate}
                                                isExporting={isExporting}
                                                isEVAAnalyseDashboard={isEVAAnalyseDashboard}
                                                selectedTemplate={selectedTemplate}
                                            />
                                            <div className='PDFDivider'></div>
                                        </>
                                    )
                                )
                            ))}
                            </div>
                            <div style={{ width : 'calc(50% - 10px)', gap: 10, flexDirection: 'column', display: 'flex'}}>
                            {dashboardItems && dashboardItems.length > 0 && dashboardItems.map((item, index) => (
                                (item.visual_type !== "Grid" || (item.visual_type === "Grid" && item.visualData.gridHeader.length < 5)) && (
                                    index % 2 === 1 && (
                                        <>
                                            <DataAnalyzerComponentItem 
                                                item={item}
                                                index={index}
                                                selectedDashboardTemplate={selectedDashboardTemplate}
                                                isExporting={isExporting}
                                                isEVAAnalyseDashboard={isEVAAnalyseDashboard}
                                                selectedTemplate={selectedTemplate}
                                            />
                                            <div className='PDFDivider'></div>
                                        </>
                                    )
                                )
                            ))}
                            </div>
                            
                        </div>
                        <div style={{ width : '100%', gap: 10, flexDirection: 'column', display: 'flex'}}>
                        {dashboardItems && dashboardItems.length > 0 && dashboardItems.map((item, index) => (
                            (item.visual_type === "Grid" && item.visualData.gridHeader.length >= 5)) && (
                                <>
                                    <DataAnalyzerComponentItem 
                                        item={item}
                                        index={index}
                                        selectedDashboardTemplate={selectedDashboardTemplate}
                                        isExporting={isExporting}
                                        isEVAAnalyseDashboard={isEVAAnalyseDashboard}
                                        selectedTemplate={selectedTemplate}
                                    />
                                    <div className='PDFDivider'></div>
                                </>
                            )
                        )}
                        </div>
                        </>}
                    </>
                    :
                        <DataAnalyzerComponentItem 
                            item={selectedItem}
                            index={0}
                            selectedDashboardTemplate={selectedDashboardTemplate}
                            isExporting={isExporting}
                            isEVAAnalyseDashboard={isEVAAnalyseDashboard}
                            selectedTemplate={selectedTemplate}
                        />
                    }
                </div>
            </div>
        </div>
    );
};

export default DataAnalyzerComponent;


// generate dashboard with separated page

// const pdf = new jsPDF('p', 'mm', 'a4');
// const pageWidth = pdf.internal.pageSize.getWidth();
// const pageHeight = pdf.internal.pageSize.getHeight();
// const margin = 15; // Slightly larger margin

// for (let i = 0; i < dashboardRefs.current.length; i++) {
//     const element = dashboardRefs.current[i]?.current;
    
//     if (!element) {
//         console.error('Report element not found');
//         return;
//     }
    
//     console.log('Element found:', element);
//     console.log('Element dimensions:', {
//         offsetWidth: element.offsetWidth,
//         offsetHeight: element.offsetHeight,
//         scrollWidth: element.scrollWidth,
//         scrollHeight: element.scrollHeight
//     });
    

//     // Force explicit styling to ensure visibility
//     const originalStyle = element.style.cssText;
//     element.style.position = 'relative';
//     element.style.display = 'block';
//     element.style.visibility = 'visible';
//     element.style.opacity = '1';
//     element.style.backgroundColor = 'white';
//     element.style.color = 'black';
//     element.style.fontFamily = 'Arial, sans-serif';
//     element.style.fontSize = '14px';
//     element.style.zIndex = '9999';

//     // Wait for styles to apply
//     await new Promise(resolve => setTimeout(resolve, 100));

//     const canvas = await html2canvas(element, {
//         scale: 2,
//         useCORS: true,
//         allowTaint: true,
//         logging: false,
//         backgroundColor: '#ffffff',
//         width: element.scrollWidth,
//         height: element.scrollHeight,
//         x: 0,
//         y: 0,
//         scrollX: 0,
//         scrollY: 0,
//         foreignObjectRendering: true,
//         removeContainer: true,
//         ignoreElements: (element) => {
//             // Skip any problematic elements
//             return element.tagName === 'IFRAME' || 
//                 element.tagName === 'OBJECT' || 
//                 element.tagName === 'EMBED';
//         }
//     });

//     // Restore original styles
//     element.style.cssText = originalStyle;

//     console.log('Canvas created:', {
//         width: canvas.width,
//         height: canvas.height
//     });

//     const imgData = canvas.toDataURL('image/png', 1.0);
    
//     if (!imgData || imgData === 'data:,' || imgData === 'data:image/png;base64,') {
//         throw new Error('Canvas produced no image data');
//     }

//     console.log('Image data generated successfully');
    
//     const imgWidth = pageWidth - 2 * margin;
//     const imgHeight = (canvas.height * imgWidth) / canvas.width;
//     const pageContentHeight = pageHeight - 2 * margin;

//     console.log('PDF dimensions:', {
//         pageWidth,
//         pageHeight,
//         imgWidth,
//         imgHeight,
//         pageContentHeight
//     });

//     // Add a title page first
//     // pdf.setFontSize(20);
//     // pdf.text(`${item.name} Report`, margin, margin + 10);
//     // pdf.setFontSize(12);
    
//     for (let i = 0; i < dashboardItems.length; i++) {
//         const visual = dashboardRefs.current[i]?.current;
//     }

//     // If content fits on remaining space of first page
//     const remainingFirstPageHeight = pageContentHeight - 30; // Account for title
//     if (imgHeight <= remainingFirstPageHeight) {
//         pdf.addImage(imgData, 'PNG', margin, margin, imgWidth, imgHeight);
//         pdf.addPage();

//     } else {
//         // Add content starting on second page
//         // 
        
//         if (imgHeight <= pageContentHeight) {
//             // Fits on one page
//             pdf.addImage(imgData, 'PNG', margin, margin, imgWidth, imgHeight);
//             pdf.addPage();
//         } else {
//             // Multi-page content
//             let yPosition = 0;
//             let pageNumber = 0;

//             while (yPosition < imgHeight) {
//                 if (pageNumber > 0) {
//                     pdf.addPage();
//                 }

//                 const remainingHeight = imgHeight - yPosition;
//                 const heightForThisPage = Math.min(remainingHeight, pageContentHeight);
                
//                 // Create cropped canvas
//                 const cropCanvas = document.createElement('canvas');
//                 const cropCtx = cropCanvas.getContext('2d');
                
//                 const sourceY = (yPosition / imgHeight) * canvas.height;
//                 const sourceHeight = (heightForThisPage / imgHeight) * canvas.height;
                
//                 cropCanvas.width = canvas.width;
//                 cropCanvas.height = sourceHeight;
                
//                 // Fill with white background first
//                 cropCtx.fillStyle = 'white';
//                 cropCtx.fillRect(0, 0, cropCanvas.width, cropCanvas.height);
                
//                 cropCtx.drawImage(
//                     canvas,
//                     0, sourceY, canvas.width, sourceHeight,
//                     0, 0, canvas.width, sourceHeight
//                 );

//                 const croppedImgData = cropCanvas.toDataURL('image/png', 1.0);
//                 pdf.addImage(croppedImgData, 'PNG', margin, margin, imgWidth, heightForThisPage);

//                 yPosition += pageContentHeight;
//                 pageNumber++;

//                 console.log(`Added page ${pageNumber + 1}, yPosition: ${yPosition}`);
//             }
//         }
//     }
// }
// // pdf.text(`Generated on: ${new Date().toLocaleDateString()}`, margin, margin + 20);
// pdf.save(`${selectedDashboardTemplate.name.replace(/\s+/g, '_')}_Report.pdf`);
// console.log('PDF saved successfully');